import Swiper, { Pagination } from 'swiper';
const el = document.querySelector('.swiper');

if (el) {
    let init = false;
    let tSlider;
    
    function topSlider() {
        if (window.innerWidth < 768) {
            if (!init) {
                init = true;
                tSlider = new Swiper(".swiper", {
                    modules: [Pagination],
                    slidesPerView: 1,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                });
            } 
        } else if (init) {
          tSlider.destroy();
          init = false;
      }
    }
    
    topSlider();
    window.addEventListener("resize", topSlider);
}
